import folderFileNavService from '@/services/folderFileNav.service'
import { TokenService } from '@/services/storage.service'
import router from '@/router'

const state =  {
}

const getters = {

}

const actions = {
    async navGPOContractFolder({commit}, payload) {
        try {
            // console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await folderFileNavService.navGPOContractFolder(payload);
            commit('setLoading', false, { root: true })            


            return result
        } catch (e) {
            // console.log(e)
            return e
        }
    },
 
 }

const mutations = {
    setUserItemAdvancedSearchParams (state, payload) {
        state.userQuoteSearchParams = payload
    }

}

export const folderFileNav = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}